export const COLUMN_SETTING = {
  no: { editable: 'never', editComponent: false, render: true },
  label: { editable: 'never', editComponent: true, render: true },
  string: { editable: 'always', editComponent: true, render: true },
  arrayToString: { editable: 'never', editComponent: false, render: true },
  multiField: { editable: 'never', editComponent: false, render: true },
  numeric: { editable: 'always', editComponent: true, render: true },
  currency: { editable: 'always', editComponent: true, render: true },
  date: { editable: 'always', editComponent: true, render: true },
  time: { editable: 'always', editComponent: true, render: true },
  datetime: { editable: 'always', editComponent: true, render: true },
  boolean: { editable: 'always', editComponent: true, render: true },
  checkbox: { editable: 'always', editComponent: true, render: true },
  active: { editable: 'always', editComponent: true, render: true },
  status: { editable: 'always', editComponent: true, render: true },
  select: { editable: 'always', editComponent: true, render: true },
  autocomplete: { editable: 'always', editComponent: true, render: true },
  freeTextSearch: { editable: 'always', editComponent: true, render: true },
  image: { editable: 'never', editComponent: true, render: true },
  mediaId: { editable: 'never', editComponent: true, render: true },
  button: { editable: 'always', editComponent: true, render: true },
  html: { editable: 'never', editComponent: false, render: true },
  calculate: { editable: 'always', editComponent: true, render: true },
  userId: { editable: 'always', editComponent: true, render: true },
  employeeCode: { editable: 'always', editComponent: true, render: true },
  jsonForm: { editable: 'never', editComponent: false, render: true },
}
